module.exports = __webpack_public_path__ + "page3.b254fd64.png";